import { get, handleError } from '@/lib/http-adapter';
import type { TopupCode } from '@/state/topup-code';
import { User } from '@/state/user';

export const getTopupCodes = async (filters?: {
  user_id?: string;
  email?: User['email'];
}) => {
  try {
    const response = await get<{ topup_codes: TopupCode[] }>(
      'public/topups/codes',
      { params: filters }
    );
    return response?.topup_codes;
  } catch (error) {
    handleError(error);
  }
};
